import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import StandingInstructionReportPageUI from './StandingInstructionReportPageUI.js'

class StandingInstructionReportPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      standingInstructionList: null
    }
  }

  render() {
    return (
      <StandingInstructionReportPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        standingInstructionList={this.state.standingInstructionList}
        loading={!this.state.standingInstructionList && !this.state.errorList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getStandingInstructions(context)
  }

  getStandingInstructions(context) {
    let cacheManager = new CacheManager({
      resource: '/api/su/standingInstructions/report',
      cacheKey: CacheKeys.StandingInstructionsReport(),
      callback: this.getStandingInstructionsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getStandingInstructionsCallback = (response) => {
    if (response && response.errorList && response.errorList.length > 0) {
      this.setState({
        errorList: response.errorList,
        standingInstructionList: null
      })
    } else if (response && response.standingInstructionsList) {
      this.setState({
        errorList: null,
        standingInstructionList: response.standingInstructionsList
      })
    } else {
      this.setState({
        errorList: null,
        standingInstructionList: []
      })
    }
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.StandingInstructionsReport())
    this.setState({
      standingInstructionList: null,
      errorList: null
    })
    this.getStandingInstructions(context)
  }
}

export default StandingInstructionReportPageSF

